import { features } from "assets"
import { path } from "constants/feature_routes_provider_view"
import NewEntry from "./New_Entry_View"
import ViewEntries from "./View_Entries"
import ViewEntry from "./View_Entry.js"
import LandingRedirect from "components/features/Landing_Redirect"

const vaccinationsProviderConfig = {
  name: "vaccinations",
  type: "feature",
  redirect: path("vaccinations/view_entries"),
  defaultRoute: path("vaccinations"),
  menuIcon: { img: features.vaccinations.main, alt: "vaccinations_icon" },
  providerView: true,
  providerEdit: true,
  nav: [
    {
      name: "landingRedirect",
      disabled: false,
      menuItem: false,
      exact: true,
      component: LandingRedirect,
      path: "/",
    },
    {
      disabled: false,
      name: "viewEntries",
      menuItem: true,
      exact: true,
      image: {
        img: features.vaccinations.viewEntries,
        alt: "vaccinations_view_entries_icon",
      },
      icon: "fas fa-copy",
      component: ViewEntries,
      path: "/view_entries",
    },
    {
      disabled: false,
      name: "newEntry",
      menuItem: true,
      image: {
        img: features.vaccinations.newEntry,
        alt: "vaccinations_new_entry_icon",
      },
      icon: "far fa-plus-square",
      component: NewEntry,
      path: "/new_entry",
    },
    {
      disabled: true,
      name: "viewEntry",
      menuItem: false,
      component: ViewEntry,
      path: "/view_entry/:id",
    },
  ],
}

export default vaccinationsProviderConfig
